/* ─── Onboarding Progress Bar ───────────────────────────────── */

interface ProgressBarProps {
    current: number; // 0-based step index
    total: number;   // total steps
}

export function ProgressBar({ current, total }: ProgressBarProps) {
    const pct = total > 0 ? ((current + 1) / total) * 100 : 0;

    return (
        <div className="w-full">
            <div className="h-1 rounded-full bg-white/[0.06] overflow-hidden">
                <div
                    className="h-full rounded-full bg-gradient-to-r from-gold-500 to-gold-400 transition-all duration-500 ease-out"
                    style={{ width: `${pct}%` }}
                />
            </div>
            <p className="text-[11px] text-text-muted mt-2 text-right tabular-nums">
                {current + 1} of {total}
            </p>
        </div>
    );
}
